import { render, staticRenderFns } from "./ComplementaryTree.vue?vue&type=template&id=434930b6&"
import script from "./ComplementaryTree.vue?vue&type=script&lang=js&"
export * from "./ComplementaryTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports